import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Thread } from "./Thread";
import PublicRoomContext from "../../../../application/Context/PublicRoomContext";
import { motion } from "framer-motion";
import { LoadingThread } from "../../shared-components/Loading/LoadingThread";
import InfiniteScroll from "react-infinite-scroll-component";
import { useTranslation } from "react-i18next";
export var ThreadsList = function () {
    var _a = React.useContext(PublicRoomContext), threads = _a.threads, hasMoreData = _a.hasMoreData, loadNewThreads = _a.loadNewThreads;
    var t = useTranslation(['public-room']).t;
    return (_jsx(motion.div, { initial: { opacity: 0 }, animate: { opacity: 1 }, transition: { duration: 0.2 }, exit: { opacity: 0 }, children: _jsx("div", { className: "posts-section", children: threads.length != 0 ?
                _jsx(InfiniteScroll, { dataLength: threads.length, next: loadNewThreads, hasMore: hasMoreData, loader: _jsx(LoadingThread, {}), height: 80 + 'vh', endMessage: _jsx("p", { style: { textAlign: "center", marginTop: "14px" }, children: _jsxs("b", { children: [" ", t("Plus de fils")] }) }), children: threads.map(function (thread, i) {
                        return _jsx(Thread, { thread: thread }, i);
                    }) })
                :
                    _jsx("div", { className: 'empty-message', children: t("Sélectionnez la chaîne !") }) }) }));
};
